import { Button, Col, Divider, Row } from 'antd';
import { SimHistoryInfo, SimHistoryResult } from 'domain/entities/SimulateEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SIM_TYPE } from 'utilities/constants/COMMON';
import { CompareModalComponent } from './components/CompareModal';
import { SimHistoryList } from './components/SimHistoryList';

export const NUMBER_MULTIPLE_DEPOSIT = 100000;

const CU05901Page = (props: AppProps) => {
    const dispatch = useAppDispatch();
    const [data, setData] = React.useState<SimHistoryResult>();
    const [isShowModal, setShowModal] = React.useState<boolean>(false);
    const [modalData, setModalData] = React.useState<SimHistoryResult>();
    const { simulateUseCase } = props;
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            await Promise.all([getHistoryList()]);
        })();
    }, []);

    useEffect(() => {
        if (modalData) {
            setShowModal(true);
        }
    }, [modalData]);

    const getHistoryList = async () => {
        try {
            dispatch(startFetching());
            const response = await simulateUseCase.getSimHistory();
            setData(response.result);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const detailClickHistory = (data?: SimHistoryInfo) => {
        if (data?.screen === 'CU-010-02') {
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_010_02}/${data?.id}`);
        } else if (data?.screen === 'CU-051-02') {
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_051_02}/${data?.id}`);
        } else if (data?.screen === 'CU-052-02') {
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_052_02}/${data?.id}`);
        } else if (data?.screen === 'CU-053-02') {
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_053_02}/${data?.id}`);
        }
    };

    const detailClickBefore = (data?: SimHistoryInfo) => {
        const historyInfo = findSimHistory(data?.id ?? 0, SIM_TYPE.BEFORE);
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_059_03}/${data?.id}`, {
            state: { simHistory: historyInfo },
        });
    };

    const detailClickConfirm = (data?: SimHistoryInfo) => {
        const historyInfo = findSimHistory(data?.id ?? 0, SIM_TYPE.CONFIRM);
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_059_03}/${data?.id}`, {
            state: { simHistory: historyInfo },
        });
    };

    const openCompareModalComponent = async () => {
        if (modalData) {
            setShowModal(true);
            return;
        }
        try {
            dispatch(startFetching());
            const response = await simulateUseCase.getSimHistory('CU-051-02');
            setModalData(response?.result);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const compareValue = (selectedValues: string[]) => {
        //format simId_simType : simtype = 10:history, 100:before, 110:confirm
        const keys1 = selectedValues[0].split('_');
        const data1 = findSimHistory(Number(keys1[0]), Number(keys1[1]));
        const keys2 = selectedValues[1].split('_');
        const data2 = findSimHistory(Number(keys2[0]), Number(keys2[1]));
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_059_02}/${keys1[0]}/${keys2[0]}`, {
            state: { data1, data2 },
        });
    };

    const findSimHistory = (id: number, type: number) => {
        if (type === SIM_TYPE.HISTORY) {
            const history = data?.history?.listSim?.find((item) => item.id === id);
            if (history) {
                return {
                    ...history,
                    type: SIM_TYPE.HISTORY,
                };
            }
        }
        if (type === SIM_TYPE.BEFORE) {
            const before = data?.beforeSim?.find((item) => item.id === id);
            if (before) {
                return {
                    ...before,
                    type: SIM_TYPE.BEFORE,
                };
            }
        }
        if (type === SIM_TYPE.CONFIRM) {
            const confirm = data?.confirmSim?.find((item) => item.id === id);
            if (confirm) {
                return {
                    ...confirm,
                    type: SIM_TYPE.CONFIRM,
                };
            }
        }
        return null;
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-059-01-container"
        >
            <PageTitle title="シミュレーション履歴" />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="form-container w-full">
                    <div className="flex flex-col justify-between items-start w-full">
                        <Divider className="mb-0" />
                        <SimHistoryList
                            data={data?.history?.listSim}
                            detailClick={detailClickHistory}
                            type="history"
                        />
                        <Divider />
                        <SimHistoryList
                            data={data?.beforeSim}
                            title="購入申込時シミュレーション"
                            detailClick={detailClickBefore}
                            type="beforeSim"
                        />
                        <Divider />
                        <SimHistoryList
                            data={data?.confirmSim}
                            title="確定シミュレーション"
                            detailClick={detailClickConfirm}
                            type="confirmSim"
                        />
                        <Row className="flex flex-col justify-between items-center w-full p-[30px]">
                            <Col className="w-full sm:w-2/3">
                                <Button
                                    className="w-auto"
                                    type="primary"
                                    size="large"
                                    onClick={openCompareModalComponent}
                                    disabled={
                                        data?.history?.listSim?.length == 0 &&
                                        data?.beforeSim?.length == 0 &&
                                        data?.confirmSim?.length == 0
                                    }
                                >
                                    キャッシュフローシミュレーション比較
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
                <CompareModalComponent
                    open={isShowModal}
                    data={modalData}
                    onOk={compareValue}
                    onCancel={() => {
                        setShowModal(false);
                    }}
                />
            </section>
        </div>
    );
};

export default CU05901Page;
